import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const PriveWealthClub = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Privé Lounge & Bakery</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Artisan Excellence & Exclusive Shopping Experience</p>
        
        <div className="card">
          <p>
            Indulge in premium artisan baked goods and exclusive shopping experiences. 
            A refined space where luxury meets culinary artistry. Browse our exquisite collection 
            and shop from our exclusive bakery offerings.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Artisan Bakery</h3>
              <p>Freshly baked daily with premium ingredients</p>
            </div>
            <div className="feature-item">
              <h3>Exclusive Products</h3>
              <p>Curated selection of luxury bakery items</p>
            </div>
            <div className="feature-item">
              <h3>Online Shopping</h3>
              <p>Convenient ordering and delivery options</p>
            </div>
            <div className="feature-item">
              <h3>Premium Quality</h3>
              <p>Only the finest ingredients and craftsmanship</p>
            </div>
          </div>

          <button 
            onClick={() => navigate('/prive-shop')}
            className="blog-read-more"
            style={{
              marginTop: '30px',
              padding: '15px 30px',
              fontSize: '16px',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <i className="fas fa-shopping-bag"></i> Shop Prive Bakery
          </button>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default PriveWealthClub;
